import { render, staticRenderFns } from "./RecibosView.vue?vue&type=template&id=12fd8a3b&scoped=true"
import script from "./RecibosView.vue?vue&type=script&lang=js"
export * from "./RecibosView.vue?vue&type=script&lang=js"
import style0 from "./RecibosView.vue?vue&type=style&index=0&id=12fd8a3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd8a3b",
  null
  
)

export default component.exports